import { Card } from "@/components/ui/card";
import {
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
} from "@/components/ui/chart";
import {
  RadarChart,
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis,
  Radar,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

const accessibilityData = [
  {
    category: "Color Contrast",
    score: 85,
    description: "Text meets WCAG 2.1 AA contrast requirements"
  },
  {
    category: "Alt Text",
    score: 90,
    description: "Images have descriptive alternative text"
  },
  {
    category: "ARIA Labels",
    score: 75,
    description: "Interactive elements properly labeled"
  },
  {
    category: "Keyboard Nav",
    score: 80,
    description: "All functions accessible via keyboard"
  },
  {
    category: "Heading Structure",
    score: 95,
    description: "Proper heading hierarchy maintained"
  },
  {
    category: "Link Text",
    score: 85,
    description: "Links have descriptive text"
  },
  {
    category: "Form Labels",
    score: 88,
    description: "Form controls properly labeled"
  },
  {
    category: "Focus Indicators",
    score: 82,
    description: "Visible focus indicators present"
  }
];

export const AccessibilityScores = () => {
  return (
    <Card className="p-6">
      <div className="space-y-4">
        <div>
          <h3 className="text-2xl font-semibold mb-2">Accessibility Analysis</h3>
          <p className="text-muted-foreground">
            Comprehensive evaluation of WCAG 2.1 compliance metrics
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          <div className="h-[400px]">
            <ChartContainer
              config={{
                score: {
                  label: "Compliance Score",
                  theme: {
                    light: "hsl(var(--primary))",
                    dark: "hsl(var(--primary))",
                  },
                },
              }}
            >
              <RadarChart data={accessibilityData} margin={{ top: 20, right: 30, bottom: 20, left: 30 }}>
                <PolarGrid gridType="circle" />
                <PolarAngleAxis
                  dataKey="category"
                  tick={{ fill: 'hsl(var(--foreground))', fontSize: 12 }}
                />
                <PolarRadiusAxis
                  angle={30}
                  domain={[0, 100]}
                  tick={{ fill: 'hsl(var(--foreground))', fontSize: 12 }}
                />
                <Tooltip content={<ChartTooltipContent />} />
                <Radar
                  name="Score"
                  dataKey="score"
                  fill="hsl(var(--primary))"
                  fillOpacity={0.5}
                  stroke="hsl(var(--primary))"
                  strokeWidth={2}
                />
              </RadarChart>
            </ChartContainer>
          </div>

          <div className="space-y-4">
            <h4 className="text-lg font-medium">Detailed Metrics</h4>
            <div className="grid gap-3">
              {accessibilityData.map((item, index) => (
                <div
                  key={index}
                  className="p-3 rounded-lg bg-card border"
                >
                  <div className="flex justify-between items-center mb-1">
                    <span className="font-medium">{item.category}</span>
                    <span className="text-primary font-bold">{item.score}%</span>
                  </div>
                  <p className="text-sm text-muted-foreground">
                    {item.description}
                  </p>
                  <div className="mt-2 h-2 bg-secondary rounded-full overflow-hidden">
                    <div
                      className="h-full bg-primary transition-all duration-500"
                      style={{ width: `${item.score}%` }}
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
};